import Button from "../..";

const PrimaryButton = ({ ...rest }) => {
  return <Button variant="primary" {...rest} />;
};

export default PrimaryButton;
